import { useQuery } from "@tanstack/react-query";
import { getAllGuardians } from "../../api/apiGuardians";
import i18next from "i18next";
export function useGetGuardians(page = 1, perPage = 15, filters = {}) {
    const { isLoading, data, error } = useQuery({ queryKey: ["guardians", page, perPage, filters, i18next.language], queryFn: () => getAllGuardians(page, perPage, filters), retry: false });
    return { isLoading, error, guardians: data?.data?.items || [], meta: data?.data?.meta || { current_page: 1, per_page: perPage, total: 0 } };
}
